import React from "react";
import "./Timeline.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import WorkIcon from "@material-ui/icons/Work";
import SchoolIcon from "@material-ui/icons/School";
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import { ThemeContext } from "../../Context/theme";

export const Timeline = () => {
  const [{ themename }] = React.useContext(ThemeContext);
  const [linecolor, setlinecolor] = React.useState(
    themename === "light" ? "#23283e" : "#fcfcfc"
  );

  React.useEffect(() => {
    if (themename === "dark") {
      setlinecolor("#fcfcfc");
    } else {
      setlinecolor("#23283e");
    }
  }, [themename]);
  return (
    <>
      <div className="section mainsection">
        <h2 className="section__title" data-aos="fade-right">
          My <span className="different">Timeline </span>
        </h2>
        <VerticalTimeline className="vertical-main" lineColor={linecolor} >
          <VerticalTimelineElement
            date={"Feb 2023 - Mar 2023"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              borderRadius: "20px",
            }}
            contentArrowStyle={{
              borderRight: "12px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<WorkIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Software Engineer Intern
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Baton Systems
            </h4>
            <p data-aos="fade-right">
            Designed and implemented a robust data ingestion pipeline with a focus on high throughput.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Aug 2021"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              borderRadius: "20px",
            }}
            contentArrowStyle={{
              borderRight: "12px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={
              <EmojiEventsIcon></EmojiEventsIcon>
              // <WorkIcon />
            }
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Winner
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Hack'KP International Hackathon
            </h4>
            <p data-aos="fade-right">
              Worked on Language-based search using AI/ML for an Advanced Darknet Search Engine for LEA.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            date={"June 2021 - July 2021"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              borderRadius: "20px",
            }}
            contentArrowStyle={{
              borderRight: "12px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<WorkIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Flutter Developer Intern
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Noob Community
            </h4>
            <p data-aos="fade-right">
              Worked on developing a Flutter Application aimed at the Next-Generation Creators from scratch.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            date={"May 2021"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              borderRadius: "20px",
            }}
            contentArrowStyle={{
              borderRight: "12px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={
              // <SchoolIcon />
              <WorkIcon></WorkIcon>
            }
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Quality Assurance Intern
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Stratecis
            </h4>
            <p data-aos="fade-right">
              Tested 20+ features and provided detailed reports on the bugs found.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Jul 2019 - Aug 2023"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              borderRadius: "20px",
            }}
            contentArrowStyle={{
              borderRight: "12px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Student [BTech. CSE]
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              CCE, APJAKT University, Kerala
            </h4>
            <p data-aos="fade-right">
            Bachelor's Degree in Computer Science and Engineering, encompassing a comprehensive range of subjects across various engineering and computer science disciplines.
Achieved a commendable CGPA of 9.1, demonstrating a strong academic performance.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"March 2019"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              borderRadius: "20px",
            }}
            contentArrowStyle={{
              borderRight: "12px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Student [HSC (Science)]
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Santhinkethan Public School, Irinjalakuda
            </h4>
            <p data-aos="fade-right">
            Completed 12th grade in Science stream with a remarkable achievement of 85.20%
            </p>
          </VerticalTimelineElement>

        
        </VerticalTimeline>
      </div>
    </>
  );
};
